var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"basic-page"},[_c('div',{staticClass:"desc-logo"},[_c('a',{attrs:{"href":"/"}},[_c('img',{attrs:{"alt":_vm.logoAlt,"src":_vm.websiteLogo}})]),_c('h1',[_vm._v(_vm._s(_vm.websiteTitle))])]),_c('div',{staticClass:"content"})])
}
var staticRenderFns = []

export { render, staticRenderFns }